var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderPound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.9696C3 6.01585 7.02944 2 12 2C16.9706 2 21 6.01585 21 10.9696C21 16.3296 15.929 20.2049 12.7799 21.8117C12.2877 22.0628 11.7123 22.0628 11.2201 21.8117C8.07101 20.2049 3 16.3296 3 10.9696ZM13.5 5.27953C11.7051 5.27953 10.25 6.74782 10.25 8.55905V10.3249H8C7.58579 10.3249 7.25 10.6638 7.25 11.0818C7.25 11.4997 7.58579 11.8386 8 11.8386H10.25V12.0908C10.25 13.3448 9.24264 14.3613 8 14.3613C7.58579 14.3613 7.25 14.7001 7.25 15.1181C7.25 15.5361 7.58579 15.8749 8 15.8749H16C16.4142 15.8749 16.75 15.5361 16.75 15.1181C16.75 14.7001 16.4142 14.3613 16 14.3613H11.0003C11.471 13.7288 11.75 12.9427 11.75 12.0908V11.8386H15C15.4142 11.8386 15.75 11.4997 15.75 11.0818C15.75 10.6638 15.4142 10.3249 15 10.3249H11.75V8.55905C11.75 7.58377 12.5335 6.79315 13.5 6.79315C14.4665 6.79315 15.25 7.58377 15.25 8.55905C15.25 8.97703 15.5858 9.31586 16 9.31586C16.4142 9.31586 16.75 8.97703 16.75 8.55905C16.75 6.74782 15.2949 5.27953 13.5 5.27953Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderPound);
export default __webpack_public_path__ + "static/media/placeholder-pound.57827d22379118b52ec74fff2d641b80.svg";
export { ForwardRef as ReactComponent };